"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const LandingStore_1 = require("../LandingStore");
const util_1 = require("util");
const react_bootstrap_1 = require("react-bootstrap");
class Video extends React.Component {
    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }
    componentWillUnmount() {
        document.body.style.overflow = 'visible';
    }
    render() {
        const src = util_1.isNullOrUndefined(this.props.src) ? "../video/Loyal_Reach_1_Final.mp4" : this.props.src;
        return React.createElement(react_bootstrap_1.Grid, { className: "landing-modal video-modal text-center" }, React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement(react_bootstrap_1.Panel, { className: "video-panel" }, React.createElement("div", { className: "modal-close video-modal-close" }, React.createElement("a", { href: "#", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Closed);
            } }, "X")), React.createElement("div", { className: "modal-video" }, React.createElement("div", { className: "embed-responsive embed-responsive-16by9" }, React.createElement("video", { width: "700", height: "500", controls: true, autoPlay: true }, React.createElement("source", { src: src, type: "video/mp4" }), "Your browser does not support the video tag.")))))));
    }
}
exports.default = Video;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/Video.tsx
// module id = 1053
// module chunks = 0 1